import NextLink from 'next/link';
import React, { AnchorHTMLAttributes, FC } from 'react';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}

const Link: FC<Props> = ({ to, children, ...rest }) => {
  return (
    <NextLink href={to}>
      <a {...rest}>{children}</a>
    </NextLink>
  );
};

export default Link;
